export const SCOPE = 'entity-select-field';
